module.exports = __webpack_public_path__ + "img/journeys-platform-spot-illustration.de901d1c.gif";